import type { KeyboardEvent as ReactKeyboardEvent } from "react";

/**
 * Enter commits/leaves a field by blurring (value already saved via onChange).
 * Shift+Enter inserts a newline in textareas.
 * Do not use inside the manuscript TipTap editors.
 */
export function handleFieldEnterKey(
  e: ReactKeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
): void {
  if (e.key !== "Enter") return;
  const isTextArea = e.currentTarget.tagName === "TEXTAREA";
  if (isTextArea && e.shiftKey) return;
  e.preventDefault();
  e.stopPropagation();
  e.currentTarget.blur();
}
